/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // HIDE BUY THREE BUG ON CLICK
  // Select the div by its class
  const bugDiv = document.querySelector('.buy-three-bug');

  // Add a click event listener
  bugDiv.addEventListener('click', function() {
    // Hide the div when clicked
    bugDiv.style.display = 'none';
  });


  // hide vendors in product descriptions
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__subheading p').forEach(function (p) {
    const spans = p.querySelectorAll('span');
    for (const s of spans) {
      const c = getComputedStyle(s).color.trim().replace(/\s+/g, '');
      // match rgb(128,128,128)
      if (c.toLowerCase() === 'rgb(128,128,128)') {
        p.style.display = 'none';
        break;
      }
    }
  });
});


const handleVariantChange = (data) => {
  const productSingle = document.querySelector('.product-single');
  if (!productSingle) return;

  const inventoryCount = productSingle.querySelector('[data-inventory-count]');
  if (!inventoryCount) return;

  const variant = data?.variant || data?.data?.variant;

  if (variant && variant.inventory_management === 'shopify') {
    const qty = variant.inventory_quantity;
    const label = qty === 1 ? 'seat' : 'seats';
    inventoryCount.textContent = `${qty} ${label} left`;
    inventoryCount.style.display = '';
  } else {
    inventoryCount.style.display = 'none';
  }
};

window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, handleVariantChange);



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
